export const prevArrow = `
    <button aria-label="Previous slide" class="slider__arrow slider__prev slick-prev button">
        <svg class="icon icon--prev" xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 24.243 42.828">
            <path id="Path_272" data-name="Path 272" d="M27,50.363l20,20,20-20" transform="translate(73.191 -25.586) rotate(90)" fill="none" stroke="currentColor" stroke-width="4"/>
        </svg>
    </button>`;
export const nextArrow = `
    <button aria-label="Next slide" class="slider__arrow slider__next slick-next button">
        <svg class="icon icon--next" xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 24.243 42.828">
            <path id="Path_272" data-name="Path 272" d="M27,50.363l20,20,20-20" transform="translate(-48.949 68.414) rotate(-90)" fill="none" stroke="currentColor" stroke-width="4"/>
        </svg>
    </button>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 300,
    nextArrow,
    prevArrow
};

